/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type { Signer, ContractDeployTransaction, ContractRunner } from "ethers";
import type { NonPayableOverrides } from "../../common";
import type {
  Transform,
  TransformInterface,
} from "../../transform.sol/Transform";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "timestamp",
        type: "uint64",
      },
    ],
    name: "TransferCreated",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type TransformConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: TransformConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Transform__factory extends ContractFactory {
  constructor(...args: TransformConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(overrides || {});
  }
  override deploy(overrides?: NonPayableOverrides & { from?: string }) {
    return super.deploy(overrides || {}) as Promise<
      Transform & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): Transform__factory {
    return super.connect(runner) as Transform__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TransformInterface {
    return new Interface(_abi) as TransformInterface;
  }
  static connect(address: string, runner?: ContractRunner | null): Transform {
    return new Contract(address, _abi, runner) as unknown as Transform;
  }
}
